import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { CalendarSevenIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'

import { createTripBooking } from '../../api/trip-bookings/create-trip-booking'
import UserNavBar from '../../components/elements/nav-bar'
import TripBookingForm from '../../components/pages/trip-bookings/trip-booking-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const TripBookingCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createTripBooking,
    onError: showAxiosError
  })

  return (
    <div>
      <UserNavBar title={'Créer une réservation'} icon={CalendarSevenIcon} />
      <div className={'h-4'} />

      <Box>
        <TripBookingForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.TRIP_BOOKING_UPDATE_PAGE.replace(':id', res.id.toString()), {
                replace: true
              })
            },
            onCancel: () => back()
          })}
        />
      </Box>
    </div>
  )
}

export default TripBookingCreatePage
